export default __webpack_public_path__ + "static/media/infiniti.92d8a3b8.png";